<!--4G温度计配置表单-->
<template>
  <el-form :model="model" ref="form" :hide-required-asterisk="mode === 'view'" label-position="right" label-width="150px" label-suffix="：">
    <el-row>
      <el-col :span="span">
        <el-form-item :label="$t('工作模式')" prop="monitorMode">
          <el-select
            v-if="!isClickConfig"
            style="width: 250px"
            v-model.trim="model.monitorMode"
          >
            <el-option
              :value="key"
              :key="key"
              :label="item.title"
              v-for="(item, key) in ENUM_RE_FOUR_G_SENSOR_WORK_MODE"
            ></el-option>
          </el-select>
          <template v-else>
            <span
              v-if="
                rowData['configStatus'] !== 2 &&
                  model['monitorModeCurrent'] &&
                  model['monitorModeCurrent'].change
              "
            >
              <template v-if="model['monitorModeCurrent'].current">
                {{
                  ENUM_RE_FOUR_G_SENSOR_WORK_MODE[
                    model['monitorModeCurrent'].current
                  ].title
                }}
              </template>
            </span>
            <span
              v-if="model['monitorModeCurrent']"
              :style="mode === 'edit' && 'color:red'"
              >{{
                ENUM_RE_FOUR_G_SENSOR_WORK_MODE[
                  model['monitorModeCurrent'].modify
                ].title
              }}</span
            >
            <span v-else-if="model.monitor_mode">
              {{ ENUM_RE_FOUR_G_SENSOR_WORK_MODE[model.monitor_mode].title }}
            </span>
          </template>
        </el-form-item>
      </el-col>
      <!--    区间变化量模式-->
      <template
        v-if="
          (model.monitorMode || model.monitor_mode) ==
            ENUM_FOUR_G_SENSOR_WORK_MODE.RANGE_CHANGE_AMOUNT
        "
      >
        <el-col :span="span">
          <el-form-item :label="$t('最小记录间隔')" prop="minRecGap">
            <el-input
              v-if="!isClickConfig"
              style="width: 250px"
              v-model.trim="model.minRecGap"
            />

            <template v-else>
              <span
                v-if="
                  rowData['configStatus'] !== 2 &&
                    model['minRecGapCurrent'] &&
                    model['minRecGapCurrent'].change
                "
                >{{ model['minRecGapCurrent'].current + '-->' }}</span
              >
              <span
                v-if="model['minRecGapCurrent']"
                :style="mode === 'edit' && 'color:red'"
                >{{ model['minRecGapCurrent'].modify }}</span
              >

              <span v-else>
                {{ model.min_rec_gap }}
              </span>
            </template>
          </el-form-item>
        </el-col>

        <el-col :span="span">
          <el-form-item :label="$t('最大记录间隔')" prop="maxRecGap">
            <el-input
              v-if="!isClickConfig"
              style="width: 250px"
              v-model.trim="model.maxRecGap"
            />

            <template v-else>
              <span
                v-if="
                  rowData['configStatus'] !== 2 &&
                    model['maxRecGapCurrent'] &&
                    model['maxRecGapCurrent'].change
                "
                >{{ model['maxRecGapCurrent'].current + '-->' }}</span
              >
              <span
                v-if="model['maxRecGapCurrent']"
                :style="mode === 'edit' && 'color:red'"
                >{{ model['maxRecGapCurrent'].modify }}</span
              >

              <span v-else>
                {{ model.max_rec_gap }}
              </span>
            </template>
          </el-form-item>
        </el-col>

        <el-col :span="span">
          <el-form-item :label="$t('采集间隔')" prop="sampleGap">
            <el-input
              v-if="!isClickConfig"
              style="width: 250px"
              v-model.trim="model.sampleGap"
            />

            <template v-else>
              <span
                v-if="
                  rowData['configStatus'] !== 2 &&
                    model['sampleGapCurrent'] &&
                    model['sampleGapCurrent'].change
                "
                >{{ model['sampleGapCurrent'].current + '-->' }}</span
              >
              <span
                v-if="model['sampleGapCurrent']"
                :style="mode === 'edit' && 'color:red'"
                >{{ model['sampleGapCurrent'].modify }}</span
              >

              <span v-else>
                {{ model.sample_gap }}
              </span>
            </template>
          </el-form-item>
        </el-col>

        <el-col :span="span">
          <el-form-item :label="$t('最大变化量')" prop="changeThreshold">
            <el-input
              v-if="!isClickConfig"
              style="width: 250px"
              v-model.trim="model.changeThreshold"
            />

            <template v-else>
              <span
                v-if="
                  rowData['configStatus'] !== 2 &&
                    model['changeThresholdCurrent'] &&
                    model['changeThresholdCurrent'].change
                "
                >{{ model['changeThresholdCurrent'].current + '-->' }}</span
              >
              <span
                v-if="model['changeThresholdCurrent']"
                :style="mode === 'edit' && 'color:red'"
                >{{ model['changeThresholdCurrent'].modify }}</span
              >
              <span v-else>
                {{ model.changeThreshold }}
              </span>
            </template>
          </el-form-item>
        </el-col>
      </template>
      <!--    同步模式-->
      <template
        v-else-if="
          (model.monitorMode || model.monitor_mode) ==
            ENUM_FOUR_G_SENSOR_WORK_MODE.SYNC
        "
      >
        <el-col :span="span">
          <el-form-item :label="$t('同步采集间隔')" prop="syncInterval">
            <el-input
              v-if="!isClickConfig"
              style="width: 250px"
              v-model.trim="model.syncInterval"
            />

            <template v-else>
              <span
                v-if="
                  rowData['configStatus'] !== 2 &&
                    model['syncIntervalCurrent'] &&
                    model['syncIntervalCurrent'].change
                "
                >{{ model['syncIntervalCurrent'].current + '-->' }}</span
              >
              <span
                v-if="model['syncIntervalCurrent']"
                :style="mode === 'edit' && 'color:red'"
                >{{ model['syncIntervalCurrent'].modify }}</span
              >

              <span v-else>
                {{ model.sync_interval }}
              </span>
            </template>
          </el-form-item>
        </el-col>
      </template>
      <!--    固定模式-->
      <template
        v-else-if="
          (model.monitorMode || model.monitor_mode) ==
            ENUM_FOUR_G_SENSOR_WORK_MODE.FIXED
        "
      >
        <el-col :span="span">
          <el-form-item :label="$t('固定采集间隔')" prop="sampleGap">
            <el-input
              v-if="!isClickConfig"
              style="width: 250px"
              v-model.trim="model.sampleGap"
            />

            <template v-else>
              <span
                v-if="
                  rowData['configStatus'] !== 2 &&
                    model['sampleGapCurrent'] &&
                    model['sampleGapCurrent'].change
                "
                >{{ model['sampleGapCurrent'].current + '-->' }}</span
              >
              <span
                v-if="model['sampleGapCurrent']"
                :style="mode === 'edit' && 'color:red'"
                >{{ model['sampleGapCurrent'].modify }}</span
              >
              <span v-else>
                {{ model.sample_gap }}
              </span>
            </template>
          </el-form-item>
        </el-col>

        <!-- bug:8459 固定模式只有采集时间 -->
        <!-- <el-col :span="span">
          <el-form-item :label="$t('正常上报间隔')" prop="norRepGap">
            <el-input
              v-if="!isClickConfig"
              style="width: 250px"
              v-model.trim="model.norRepGap"
            />

            <template v-else>
              <span
                v-if="
                  rowData['configStatus'] !== 2 &&
                    model['norRepGapCurrent'] &&
                    model['norRepGapCurrent'].change
                "
                >{{ model['norRepGapCurrent'].current }}</span
              >
              <span
                v-if="model['norRepGapCurrent']"
                :style="mode === 'edit' && 'color:red'"
                >{{ model['norRepGapCurrent'].modify }}</span
              >

              <span v-else>
                {{ model.nor_rep_gap }}
              </span>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="span">
          <el-form-item :label="$t('异常上报间隔')" prop="abnorRepGap">
            <el-input
              v-if="!isClickConfig"
              style="width: 250px"
              v-model.trim="model.abnorRepGap"
            />

            <template v-else>
              <span
                v-if="
                  rowData['configStatus'] !== 2 &&
                    model['abnorRepGapCurrent'] &&
                    model['abnorRepGapCurrent'].change
                "
                >{{ model['abnorRepGapCurrent'].current }}</span
              >
              <span
                v-if="model['abnorRepGapCurrent']"
                :style="mode === 'edit' && 'color:red'"
                >{{ model['abnorRepGapCurrent'].modify }}</span
              >
              <span v-else>
                {{ model.abnor_rep_gap }}
              </span>
            </template>
          </el-form-item>
        </el-col> -->
      </template>
    </el-row>
  </el-form>
</template>

<script>
import { ENUM_RE_FOUR_G_SENSOR_WORK_MODE } from '@/common/enum/reverse/device'

import { ENUM_FOUR_G_SENSOR_WORK_MODE } from '@/common/enum/forward/device'
import { getFourGTempConfigDefault } from '@/pages/equipment/sensor/components/sensor/cionfig/children/device/FourGTempConfig/default'
import Modify from '@/pages/equipment/gateway/modal/ConfigDialog/GenTwo/component/Modify.vue'

/**
 * 4G温度计类型配置封装
 * 外部参数格式化有两种方式  获取需要提交数据调用本组件getData  会自动进行校验
 * 1.调用setData 适用于服务器原生为经过处理的数据
 * 2.传入dioForm  适用于已经格式化好的数据
 */
export default {
  components: { Modify },
  computed: {
    ENUM_FOUR_G_SENSOR_WORK_MODE() {
      return ENUM_FOUR_G_SENSOR_WORK_MODE
    },
    ENUM_RE_FOUR_G_SENSOR_WORK_MODE() {
      return ENUM_RE_FOUR_G_SENSOR_WORK_MODE
    },
    mode() {
      return this.dioForm ? 'view' : 'edit'
    }
  },
  props: {
    isClickConfig: {},
    rowData: { default: () => ({}) },
    dioForm: {},
    span: { default: 24 }
  },
  data() {
    return {
      model: {}
    }
  },
  watch: {
    dioForm: {
      immediate: true,
      handler() {
        if (this.dioForm && this.dioForm.monitor_mode) {
          this.model = { ...this.dioForm }
        } else {
          this.model = getFourGTempConfigDefault()
        }
      }
    }
  },
  methods: {
    // export 给外部调用
    async getData() {
      await this.$refs.form.validate()
      return this.model
    },
    // export给外部赋值使用
    setData(JsonContent) {
      this.model = {
        monitorMode: JsonContent.item.monitor_mode.modify,
        monitorModeCurrent: JsonContent.item.monitor_mode,

        sampleGap:
          JsonContent.item.sample_gap && JsonContent.item.sample_gap.modify,
        sampleGapCurrent: JsonContent.item.sample_gap,

        maxRecGap:
          JsonContent.item.max_rec_gap && JsonContent.item.max_rec_gap.modify,
        maxRecGapCurrent: JsonContent.max_rec_gap,

        minRecGap:
          JsonContent.item.min_rec_gap && JsonContent.item.min_rec_gap.modify,
        minRecGapCurrent: JsonContent.item.min_rec_gap,

        changeThreshold:
          JsonContent.item.change_threshold &&
          JsonContent.item.change_threshold.modify,
        changeThresholdCurrent: JsonContent.item.change_threshold,

        norRepGap:
          JsonContent.item.nor_rep_gap && JsonContent.item.nor_rep_gap.modify,
        norRepGapCurrent: JsonContent.item.nor_rep_gap,

        abnorRepGap:
          JsonContent.item.abnor_rep_gap &&
          JsonContent.item.abnor_rep_gap.modify,
        abnorRepGapCurrent: JsonContent.item.abnor_rep_gap,

        syncInterval:
          JsonContent.item.sync_interval &&
          JsonContent.item.sync_interval.modify,
        syncIntervalCurrent: JsonContent.item.sync_interval
      }
    }
  }
}
</script>
